import './ErrorMessage.css';

export const ErrorMessage = ({ message }: { message?: string }): JSX.Element => {
	return (
		<div className="error-message">
			<em>{message ?? 'Error loading data'}</em>
		</div>
	);
};
